import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../store/slices/userSlice";
import { Link } from "react-router-dom";
import MobileAccountMenu from "./MobileAccountMenu";
import { useLocation } from "react-router-dom";

const TopHeader = (props) => {
  const { isAuthenticated, user } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isComptePage = pathname.startsWith("/compte");
  //  console.log('props?.btn',isAuthenticated,user)

  const handleLogout = () => {
    dispatch(logout());
  };

  return (
    <div
      className={`${props?.btn ? "sticky" : ""}  ${
        props?.bg ? "bg-header" : ""
      }`}
    >
      <div className="container-fluid twyny-border-bottom mb-0 pb-0">
        <header className="container d-flex justify-content-between align-items-center twyny-topbar">
          <div className="logo">
            <Link to="/">
              <img
                src="/images/twyLogo.svg"
                alt="Twyny Logo"
                className="logo-img"
              />
            </Link>
          </div>
          {props?.btn && (
            <>
              {" "}
              <div className="desktopOnly d-lg-block d-md-none d-none">
                {isAuthenticated ? (
                  <Link
                    to={
                      user?.role === "prestataire"
                        ? "/compte/prestataire/accueil"
                        : "/compte/informations-personnel"
                    }
                    className="user-profile-link"
                  >
                    <img
                      src="/images/user-profile.svg"
                      alt="user-profile"
                      className="user-profile-img"
                    />
                    {user?.prenom} {user?.nom}
                  </Link>
                ) : (
                  <>
                    <Link
                      to="/registerPrestataire"
                      className="twyny-cta-list mr-8"
                    >
                      <button className=" twyny-cta-secondary">
                        Devenir partenaire
                      </button>
                    </Link>

                    <Link to="/login" className="twyny-cta-list ml-8">
                      <button className=" twyny-cta-primary">
                        Se connecter
                      </button>
                    </Link>
                  </>
                )}
              </div>
              <div className="d-lg-none d-md-block d-block">
                {isComptePage ? <MobileAccountMenu /> : ""}
              </div>
            </>
          )}
        </header>
      </div>
    </div>
  );
};
export default TopHeader;
